import React from "react";

const StockCreateSubcategoryScreen = () => {
  return <div>StockCreateSubcategoryScreen</div>;
};

export default StockCreateSubcategoryScreen;
